import { isPropertyKind } from './clientTypes';

export function workspaceKind(user) {
  if (!user) return 'guest';
  if (user.is_platform_owner) return 'platform';
  if (user.account_type === 'vendor' || user.role === 'photographer') return 'vendor';
  // 'builder' (pre-construction developers/builders) and 'reit_leasing'
  // (REITs/leasing companies) are distinct, tailored account types — see
  // Bricks-OS CLAUDE.md's "New Vertical" section.
  // investor, commercial and property_manager join them (lib/clientTypes.js).
  if (isPropertyKind(user.account_type)) return user.account_type;
  if (user.profile_pending && !user.subscription_type) return 'pending';
  const sub = user.subscription_type || 'brokerage';
  const role = user.role || 'user';
  const isManager = role === 'manager' || role === 'admin';
  if (sub === 'solo') return 'solo';
  if (sub === 'team') return isManager ? 'team_lead' : 'team_member';
  return isManager ? 'brokerage_manager' : 'agent';
}
